<template>
  <div>
    <div class="content-container">
      Zaproś znajomych i zyskaj
      <span style="font-weight: 600;">10 zł rabatu</span> na subskrypcję
      platformy DagaJoga!

      <svg
        @click="openModal"
        style="margin-left: 10px; cursor: pointer;"
        width="101"
        height="16"
        viewBox="0 0 101 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100.707 8.70711C101.098 8.31658 101.098 7.68342 100.707 7.29289L94.3431 0.928932C93.9526 0.538408 93.3195 0.538408 92.9289 0.928932C92.5384 1.31946 92.5384 1.95262 92.9289 2.34315L98.5858 8L92.9289 13.6569C92.5384 14.0474 92.5384 14.6805 92.9289 15.0711C93.3195 15.4616 93.9526 15.4616 94.3431 15.0711L100.707 8.70711ZM0 9L100 9V7L0 7L0 9Z"
          fill="#6D6963"
        />
      </svg>
      <div v-if="userRefLinksAmount" class="amount">
        <p>
          Twój całkowity rabat: <b>{{ userRefLinksAmount.toFixed(2) }} zł</b>
        </p>
      </div>
      <ref-links-info-modal
        :label="'Jak to działa?'"
        @closeModal="closeModal"
        :isVisible="infoModal"
        :userId="userId"
      />
    </div>
  </div>
</template>

<script>
import RefLinksInfoModal from "./modals/RefLinksInfoModal.vue";
export default {
  props: ["userId", "userRefLinksAmount"],
  components: { RefLinksInfoModal },
  name: "RefLinksInfo",
  data() {
    return {
      infoModal: false,
    };
  },
  setup() {
    return {};
  },
  methods: {
    closeModal() {
      this.infoModal = false;
    },
    openModal() {
      this.infoModal = true;
    },
  },
};
</script>

<style scoped>
.content-container {
  text-align: left;
  width: fit-content;
  padding: 15px 0;
}

.amount {
  font-size: 19px;
  margin-top: 20px;
}
</style>
